
import { RoutePermittedRole } from "shared/constants/AppConst";
import Centre from "./centre";
import CentreIndex from "./centre/CentreCreate";
import Mapping from "./mapping";



export const centreConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    
    path: "/suppor/supportViewCategories",
    element: <Centre />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "support/supportCentre/centre",
    element: <Centre />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/support/Centre/CentreCreate",
    element: <CentreIndex/>,
  }, 
  {
    permittedRole: RoutePermittedRole.User,
    path: "/support/supportCentre/CentreCreate/:sNo",
    element: <CentreIndex />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/suppor/supportViewMappinge",
    element: <Mapping />,
  },

];


